import { render, staticRenderFns } from "./FlightReservation.vue?vue&type=template&id=378843ac&scoped=true"
import script from "./FlightReservation.vue?vue&type=script&lang=js"
export * from "./FlightReservation.vue?vue&type=script&lang=js"
import style0 from "./FlightReservation.vue?vue&type=style&index=0&id=378843ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378843ac",
  null
  
)

export default component.exports